module.exports = "/_next/static/resources/pack-55a63239aed35d1172fae6cf7a1270fc.webp";